import { render } from "./report-google.vue?vue&type=template&id=2deca2c1"
import script from "./report-google.vue?vue&type=script&lang=js"
export * from "./report-google.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__